/**
 * Utility helpers for ImportTypeSetting
 *
 * ImportType mapping:
 *   1: QRコード               → 1 field (buttonLabel, max 32)
 *   2: ICカードリーダー        → 1 field (buttonLabel, max 32)
 *   3: 顔認証                 → 1 field (buttonLabel, max 32)
 *   4: 顔認証（セキュリティ強化版） → 1 field (buttonLabel, max 32)
 *   5: 従業員コード（NEW）      → 3 fields (textboxLabel/placeholder max 12, confirmButton max 20)
 */

export interface ImportTypeSettingEntry {
    useDefault: boolean;
    customValue: string | null;
}

export type ImportTypeSettingMap = Record<string, Record<string, ImportTypeSettingEntry>>;

export const IMPORT_TYPE_CODE_INPUT = 5;

export const IMPORT_TYPE_OPTIONS: Array<{ value: number; label: string }> = [
    { value: 1, label: 'QRコード' },
    { value: 2, label: 'ICカードリーダー' },
    { value: 3, label: '顔認証' },
    { value: 4, label: '顔認証（セキュリティ強化版）' },
    { value: 5, label: '従業員コード' },
];

const CODE_INPUT_FIELDS = ['textboxLabel', 'placeholder', 'confirmButton'];

const BUTTON_LABEL_FIELDS = ['buttonLabel'];

const FIELD_MAX_LENGTH: Record<string, number> = {
    buttonLabel: 32,
    textboxLabel: 12,
    placeholder: 12,
    confirmButton: 20,
};

const DEFAULT_MAX_LENGTH = 32;

const DEFAULT_LABELS: Record<string, Record<string, string>> = {
    '1': { buttonLabel: 'カメラ起動' },
    '2': { buttonLabel: 'ICカードリーダーにカードを置いてこちらをタップしてください' },
    '3': { buttonLabel: 'カメラ起動' },
    '4': { buttonLabel: 'カメラ起動' },
    '5': {
        textboxLabel: '従業員コード',
        placeholder: '入力してください',
        confirmButton: '確定',
    },
};

export const getFieldsForImportType = (importType: number): string[] => {
    if (importType === IMPORT_TYPE_CODE_INPUT) {
        return [...CODE_INPUT_FIELDS];
    }
    if (importType >= 1 && importType <= 4) {
        return [...BUTTON_LABEL_FIELDS];
    }
    return [];
};

export const getMaxLengthForField = (field: string): number =>
    FIELD_MAX_LENGTH[field] ?? DEFAULT_MAX_LENGTH;

export const getDefaultLabelForField = (importType: number, field: string): string =>
    DEFAULT_LABELS[String(importType)]?.[field] ?? '';

export const createDefaultSettingForImportType = (
    importType: number,
): Record<string, ImportTypeSettingEntry> => {
    const fields = getFieldsForImportType(importType);
    return Object.fromEntries(fields.map((f) => [f, { useDefault: true, customValue: null }]));
};
